import state from './moduleMenuState.js'
import mutations from './moduleMenuMutations.js'
import actions from './moduleMenuActions.js'
import getters from './moduleMenuGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}